import React, { useCallback, useState } from 'react'
import dayjs, { Dayjs } from 'dayjs'
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import Button from '@mui/material/Button'
import ClearIcon from '@mui/icons-material/Clear'
import DateRangePicker from '../../../components/DateRangePicker'
import useAxios from '../../../hooks/useAxios'
import { PaginationResponseInterface } from '../../../types/pagination'
import { IProduct } from '../../../types/product'
import { ICategory } from '../../../types/category'
import { IDistributionChannel } from '../../../types/distribution-channel'
import SelectSearchMultiple, {
  IOptionSelect,
} from '../../../components/SelectSearchMultiple'
import ExportExcel from '../../../components/Export'
import { AllowShippingProviderLists } from '../../../utils/provider'
import { useUser } from '../../../hooks/useUser'
import { ImageLinks, LogoTypeProvider } from '../../../constants/image-link'
import ProductSelectSearch from '../../../components/SelectSearch/ProductSelectSearch'
import CategorySelectSearch from '../../../components/SelectSearch/CategorySelectSearch'
import ChannelSelectSearch from '../../../components/SelectSearch/ChannelSelectSearch'

export interface IFilterMapped {
  startDate?: string
  endDate?: string
  // provider?: string;
  categoryObjectIds?: string[]
  distributionObjectIds?: string[]
  distributionChannels?: string[]
  productObjectIds?: string[]
  products?: string[]
  categories?: string[]
  shippingProvider?: string | any
  trackingStatus?: string
  page?: number
  perPage?: number
  isTelesale?: string
  dateType?: string
}

interface FilterGroupProps {
  filter: IFilterMapped
  onFilterChange: (filter: IFilterMapped) => void
  onSearch: (filter: IFilterMapped) => void
  showSippingProvider?: boolean
  showCategory?: boolean
  showDistributionChannel?: boolean
  showProduct?: boolean
  showDownload?: boolean
  onDownload?: (date: Dayjs) => void
}

const CancelledOrderReportFilter = (props: FilterGroupProps) => {
  const { merchant } = useUser()
  const {
    filter,
    onFilterChange,
    onSearch,
    showSippingProvider = true,
    showCategory = true,
    showDistributionChannel = true,
    showProduct = true,
    showDownload = true,
    onDownload,
  } = props
  const {
    startDate,
    endDate,
    productObjectIds,
    distributionObjectIds,
    categoryObjectIds,
  } = filter
  const [searchProduct, setSearchProduct] = useState<string>('')
  const [searchCategory, setSearchCategory] = useState<string>('')
  const [searchDistributionChannel, setSearchDistributionChannel] =
    useState<string>('')
  const [resetAutoComplete, setResetAutoComplete] = useState<string>('')

  const handleFilterChange = useCallback(
    (newFilter: IFilterMapped) => {
      onFilterChange({ ...filter, ...newFilter })
    },
    [filter, onFilterChange],
  )

  return (
    <Grid container spacing={2} mb={2}>
      <Grid item xs={12} lg={2}>
        <TextField
          fullWidth
          label="ประเภทวันที่"
          value={filter.dateType || 'createdAt'}
          onChange={(e) => handleFilterChange({ dateType: e.target.value })}
          select
        >
          <MenuItem value="createdAt">วันที่ยกเลิก/ตีกลับ สินค้า</MenuItem>
          <MenuItem value="orderDate">วันที่คำสั่งซื้อ</MenuItem>
          {/* <MenuItem value="upsale">วันที่เพิ่มสินค้า (Upsale)</MenuItem> */}
        </TextField>
      </Grid>
      <Grid item xs={12} lg={4}>
        <DateRangePicker
          startDate={startDate}
          endDate={endDate}
          onChange={(startDate, endDate) => {
            onFilterChange({ ...filter, startDate, endDate })
          }}
        />
      </Grid>

      <Grid item xs={12} lg={showDownload ? 2 : 4}>
        <Button
          color="primary"
          size="large"
          fullWidth
          variant="contained"
          startIcon={<SearchIcon />}
          onClick={() => onSearch(filter)}
          sx={{ height: '100%' }}
        >
          ค้นหา
        </Button>
      </Grid>
      <Grid item xs={4} lg={2}>
        <Button
          color="inherit"
          size="large"
          fullWidth
          variant="contained"
          startIcon={<ClearIcon />}
          onClick={() => {
            onFilterChange({
              categoryObjectIds: undefined,
              distributionObjectIds: undefined,
              productObjectIds: undefined,
              shippingProvider: 'all',
              trackingStatus: 'tracking',
              startDate: dayjs().subtract(30, 'days').format(),
              endDate: dayjs().format(),
            })
            onSearch({
              categoryObjectIds: undefined,
              distributionObjectIds: undefined,
              productObjectIds: undefined,
              shippingProvider: 'all',
              trackingStatus: 'tracking',
              startDate: dayjs().subtract(30, 'days').format(),
              endDate: dayjs().format(),
            })
            setResetAutoComplete(new Date().getTime().toString())
          }}
          sx={{ height: '100%' }}
        >
          รีเซ็ต
        </Button>
      </Grid>
      {showDownload && (
        <Grid item xs={12} lg={2}>
          <ExportExcel onDownload={onDownload} filterDate={false} />
        </Grid>
      )}
    </Grid>
  )
}

export default CancelledOrderReportFilter
